export const getDefaultAddonNameTranslation = (type: string) => {
  if (type === 'drinks') return 'addons:defaultDrinksName';
  if (type === 'insurance') return 'addons:defaultInsuranceName';
  if (type === 'transport') return 'addons:defaultTransportName';
  if (type === 'accommodation') return 'addons:defaultAccommodation';
  if (type === 'donation') return 'addons:defaultDonationName';
  if (type === 'other') return 'addons:defaultOthersName';

  return '';
};
